<template>
  <div class="loyalty-store-purchases-report">
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back banner-back-button" :title="$t('general.back')" href="#" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="mar-lt-10" v-if="rewardTitle">
          <strong>{{ $t('loyaltyStore.purchases') }}:</strong> {{ rewardTitle }}
        </p>
      </div>
    </div>

    <div class="sales-report mar-to-15">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination pad-15">
            <el-table
              v-loading="loading"
              :data="tableData"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
            >
              <el-table-column :label="$t('loyaltyStore.datetime')" min-width="140">
                <template slot-scope="props">
                  {{ formatDateTime(props.row.created_at || props.row.datetime) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.user')" min-width="140">
                <template slot-scope="props">
                  {{ getUserName(props.row) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reports.location')" min-width="120">
                <template slot-scope="props">
                  {{ locationName(props.row.location_id) || props.row.location_name || '—' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.pointsCost')" width="110">
                <template slot-scope="props">
                  {{ props.row.loyalty_points_spent }}
                </template>
              </el-table-column>
              <el-table-column v-if="isProductType" :label="$t('loyaltyStore.orderId')" width="120">
                <template slot-scope="props">
                  <a
                    v-if="props.row.order_id"
                    href="#"
                    class="text-info"
                    @click.prevent="openOrder(props.row.order_id)"
                  >
                    {{ props.row.order_id }}
                    <span v-if="props.row.order && props.row.order.status">({{ props.row.order.status }})</span>
                  </a>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column v-if="isGiftType" :label="$t('loyaltyStore.giftCardId')" width="120">
                <template slot-scope="props">
                  {{ props.row.gift_card_id || '—' }}
                </template>
              </el-table-column>
              <el-table-column v-if="isGiftType" :label="$t('loyaltyStore.giftCardValue')" width="130">
                <template slot-scope="props">
                  {{ props.row.gift_card_value != null ? parseFloat(props.row.gift_card_value).toFixed(2) : '—' }} {{ currency }}
                </template>
              </el-table-column>
            </el-table>

            <div style="margin-top: 15px; text-align: right;">
              <el-pagination
                layout="prev, pager, next"
                :total="total"
                :page-size="perPage"
                :current-page.sync="page"
                @current-change="loadPurchases"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Table, TableColumn, Pagination } from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)

export default {
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      perPage: 50,
      locationMap: {},
      currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {})['currency_iso'])
    }
  },
  computed: {
    rewardId () {
      const fromProp = this.route && this.route.params && this.route.params.rewardId
      const fromRouter = this.$route && this.$route.params && this.$route.params.rewardId
      return fromProp || fromRouter
    },
    rewardTitle () {
      return (this.$route && this.$route.query && this.$route.query.title) || ''
    },
    rewardType () {
      return (this.$route && this.$route.query && this.$route.query.type) || 'product'
    },
    isProductType () {
      return this.rewardType !== 'gift_card'
    },
    isGiftType () {
      return this.rewardType === 'gift_card'
    }
  },
  mounted () {
    this.initLocations()
    this.loadPurchases()
  },
  methods: {
    initLocations () {
      const company = this.$session.get('selectedCompanyData') || {}
      const locs = company.locations_details || []
      const map = {}
      locs.forEach((l) => {
        const id = l.true_id || l.id
        if (id != null) map[id] = l.name
      })
      this.locationMap = map
    },
    locationName (locationId) {
      if (!locationId) return null
      return this.locationMap[locationId] || this.locationMap[String(locationId)] || null
    },
    goBack () {
      this.$bus.$emit('close-modal')
      this.$bus.$emit('refresh-loyalty-store-report')
    },
    getUserName (row) {
      if (row.user && row.user.name) return row.user.name
      if (row.user) {
        return [row.user.firstname, row.user.lastname].filter(Boolean).join(' ') || row.user.email || row.user_id
      }
      return row.user_id || '—'
    },
    formatDateTime (val) {
      if (!val) return '—'
      if (typeof this.formatDate === 'function') return this.formatDate(val)
      return String(val)
    },
    openOrder (orderId) {
      this.$router.push('/orders/view/' + orderId)
    },
    loadPurchases () {
      if (!this.rewardId) return
      this.loading = true
      const q = (this.$route && this.$route.query) || {}
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.page,
        per_page: this.perPage
      }
      if (q.start_date) params.start_date = q.start_date
      if (q.end_date) params.end_date = q.end_date
      if (q.location_id) params.location_id = q.location_id
      if (q.user_id) params.user_id = q.user_id

      this.apiRequest('/reports/loyalty-store/rewards/' + this.rewardId + '/purchases', 'GET', params, (response) => {
        this.loading = false
        if (response.status && response.data) {
          this.tableData = response.data.items || []
          this.total = response.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/LoyaltyStorePurchasesReport.vue